
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2937',
  depVersions: {
  "customer-portal-app": "static-1.2937",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.489",
  "data-fetching-client": "static-1.9867",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25978",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5803",
  "hs-test-utils": "static-1.8235",
  "hub-http": "static-1.6427",
  "hub-http-shared-msw-handlers": "static-1.10457",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18816",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11684",
  "I18n": "static-7.1651",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6664",
  "payment-link-components": "static-1.23991",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7309",
  "quartz-core": "static-1.6528",
  "quartz-i18n": "static-1.984",
  "react": "static-7.189",
  "react-colorpicker": "static-2.10419",
  "react-dlb": "static-1.83",
  "react-utils": "static-2.5487",
  "reselect": "static-3.8",
  "rich-text-lib": "static-1.20181",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18272",
  "ui-components-test-utils": "static-1.5821",
  "UIComponents": "static-3.8630",
  "foundations-assets": "static-1.5085",
  "foundations-components": "static-1.8319",
  "foundations-theming": "static-1.4654",
  "foundations-theming-specialty": "static-1.2370",
  "framer-motion": "static-1.75",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1283",
  "quartz-config": "static-1.1087",
  "quartz-routing": "static-1.739",
  "quick-fetch": "static-1.4063",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16913",
  "rpc-client-utils": "static-1.4868",
  "sanitize-text": "static-1.8357",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.58",
  "ui-addon-draggable": "static-3.4964",
  "ui-addon-react-router-dom": "static-1.9743",
  "usage-tracker": "static-1.7562",
  "usage-tracker-anonymous": "static-1.5979",
  "usage-tracker-core": "static-1.7412",
  "video-components-external": "static-1.11937",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3545",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3586",
  "quartz-webpack": "static-1.3533",
  "bend-plugin-quartz-routing": "static-1.387",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "customer-data-objects": "static-1.7892",
  "frontend-preferences-client": "static-1.8136",
  "laboratory-lib": "static-3.7361",
  "onboarding-scopes": "static-1.6668",
  "seat-types-lib": "static-1.486",
  "ui-addon-opt": "static-4.8570",
  "HeadJS": "static-2.782",
  "hs-test-utils-bend-plugin": "static-1.3346",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.227",
  "ts-schema": "static-1.4226",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8069",
  "content-media-capture": "static-1.5173",
  "cssUtils": "static-1.855",
  "customer-data-ui-utilities": "static-1.10034",
  "file-manager-components": "static-1.24234",
  "HubStyle": "static-2.11991",
  "knowledge-content-types": "static-1.8601",
  "PatternValidationJS": "static-1.3107",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.491",
  "ui-addon-emoji-picker": "static-1.10095",
  "ui-addon-i18n": "static-1.11357",
  "ui-business-units-lib": "static-1.9290",
  "ui-shepherd-react": "static-3.10471",
  "video-data-lib": "static-1.35595",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4533",
  "commerce-tours-lib": "static-1.6478",
  "customer-data-properties": "static-1.52297",
  "getting-started-shared-tasks": "static-1.19012",
  "growth-onboarding-reliability": "static-1.5292",
  "onboarding-tours": "static-1.16980",
  "reference-resolvers-lite": "static-1.8305",
  "sales-checkout-service-client": "static-1.3743",
  "ui-addon-iframeable": "static-1.9283",
  "user-context": "static-1.5321",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.859",
  "hubspotter-http": "static-1.4797",
  "icons": "static-2.668",
  "mobile-manifest-mixins": "static-1.556",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.984",
  "quartz-head": "static-1.974",
  "quartz-test": "static-1.984",
  "quartz-tracking": "static-1.688",
  "trellis-components": "static-1.2374",
  "ui-fonts": "static-1.946",
  "usage-tracker-container": "static-1.7552",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9635",
  "data-token-picker": "static-1.16762",
  "FileManagerLib": "static-1.39874",
  "property-translator": "static-1.5605",
  "atom": "static-1.5286",
  "merchandise-lib": "static-1.269",
  "purchase-motions-components": "static-1.6229",
  "salesImages": "static-1.529",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5802",
  "react-create-root-preference": "static-1.51",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.102",
  "ui-images": "static-2.1215",
  "bend-plugin-foundations-components": "static-1.4588",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "trellis-assets": "static-1.2355",
  "bend-plugin-foundations-theming": "static-1.3137",
  "foundations-theming-base": "static-1.3639",
  "stylex": "static-1.37",
  "interframe": "static-3.4965",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5976",
  "web-vitals": "static-1.9",
  "bend-plugin-chirp-manifest": "static-1.278",
  "chirp-fetch": "static-1.2097",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4687",
  "react-flip-move": "static-1.74",
  "apollo-link-hub-http": "static-2.4864",
  "content-media-composition-data-lib": "static-1.12977",
  "content-media-compositions": "static-2.16984",
  "idb-keyval": "static-1.47",
  "immer": "static-1.33",
  "immerable": "static-1.4358",
  "magpie-lib": "static-1.5699",
  "magpie-types": "static-1.5159",
  "media-bridge-lib": "static-1.19278",
  "bender-build-tools": "static-1.3323",
  "inbound-db-properties-service-client": "static-1.3991",
  "superstore": "static-1.4968",
  "feedback-loader": "static-1.29672",
  "ai-components-ui-library": "static-1.9477",
  "ui-addon-video-player": "static-1.8916",
  "ui-coaching-tips": "static-1.29130",
  "ContentUtils": "static-1.68959",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4635",
  "sassPrefix": "static-1.160",
  "react-dnd-compat": "static-1.4824",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1448",
  "copilot-toolkit": "static-1.11662",
  "avatar-components": "static-1.2707",
  "navigation-messaging": "static-1.7947",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8387",
  "commerce-products-lib": "static-1.10296",
  "crm-message-bus": "static-1.43558",
  "growth-data-modal": "static-1.5760",
  "hubspot-apollo-client": "static-1.5087",
  "onboarding-tours-client": "static-1.5194",
  "batch-promise": "static-1.1754",
  "calling-global-api": "static-1.65209",
  "calling-internal-common": "static-1.31524",
  "calling-lifecycle-internal": "static-1.66591",
  "calling-lifecycle-messages": "static-1.58885",
  "conditional-properties-service-client": "static-1.3943",
  "crm-links": "static-1.6527",
  "crm-index-visualization-core": "static-1.4411",
  "crm-pipelines-api-client-types": "static-1.4282",
  "customer-data-objects-ui-components": "static-1.13240",
  "customer-data-properties-shared-msw-handlers": "static-1.9784",
  "customer-data-property-utils": "static-1.8305",
  "external-options-client-types": "static-1.4272",
  "formula-editor": "static-1.14616",
  "framework-data-schema-resolvers": "static-1.7104",
  "google-libphonenumber": "static-1.41",
  "hs-resources": "static-1.390",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4362",
  "meetings-icalendar-utils-lib": "static-1.841",
  "multi-currency-client-types": "static-1.3837",
  "object-builder-ui-client": "static-1.49412",
  "pipeline-validation-client-types": "static-1.4112",
  "property-value-citations": "static-1.2911",
  "pulse": "static-1.826",
  "smart-property-lib": "static-1.8104",
  "tiered-pricing": "static-1.1788",
  "topics-actions-lib": "static-1.365",
  "ui-addon-form-validation": "static-1.11197",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3270",
  "growth-onboarding-next-action-utils": "static-1.2508",
  "navigation-components": "static-1.18620",
  "onboarding-tours-utils": "static-1.1046",
  "ui-shepherd-tracker": "static-1.7852",
  "ui-universal-auth": "static-1.9229",
  "getting-started-shared-tasks-store": "static-1.18130",
  "hubspotter-http-shared-msw-handlers": "static-1.10455",
  "usage-tracker-session-replay": "static-1.5248",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1163",
  "tanstack-virtual": "static-1.33",
  "audio-components": "static-1.6219",
  "FileManagerCore": "static-1.39733",
  "FileManagerImages": "static-1.37385",
  "video-components": "static-1.13939",
  "foundations-components-legacy": "static-1.1344",
  "purchase-motions-api": "static-1.6232",
  "signup-constants": "static-1.19391",
  "signup-ui-url-generator": "static-2.8267",
  "usage-tracker-public": "static-1.7373",
  "reactive-lib": "static-1.932",
  "simple-logging-lib": "static-1.3259",
  "chatspot-core": "static-1.22365",
  "growth-onboarding-feedback-components": "static-1.6791",
  "cms-field-types": "static-1.5025",
  "content-icons-ui": "static-1.2291",
  "integrations-lib": "static-1.16801",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.426",
  "breeze-engine-core": "static-1.726",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.986",
  "customer-data-tracking": "static-1.7094",
  "products-iframe-lib": "static-1.8420",
  "products-ui-components-shared-msw-handlers": "static-1.10839",
  "restore-request-side-panel-lib": "static-1.1423",
  "onboarding-data-sync-lib": "static-1.2324",
  "hubspot-apollo-cache": "static-1.546",
  "calling-error-reporting": "static-1.31531",
  "shared-worker-versioning": "static-1.11247",
  "calling-usage-tracker": "static-1.6750",
  "voice-sms-access-library": "static-1.1735",
  "conversations-skeleton-state": "static-1.7457",
  "location-customization-utils-lib": "static-1.9887",
  "crm-index-associations-lib": "static-1.6651",
  "framework-data-schema-quick-fetch": "static-1.7009",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10540",
  "redux-toolkit": "static-1.7",
  "sales-views-client-types": "static-1.4466",
  "bark-lib": "static-1.16708",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6097",
  "react-codemirror": "static-1.10850",
  "fdsr-migration-layer": "static-1.223",
  "framework-builder-read-service-client": "static-1.4152",
  "persist-promise": "static-1.3911",
  "event-emitter": "static-1.1160",
  "bend-plugin-pulse": "static-1.329",
  "fast-json-patch": "static-1.66",
  "data-agent-kit": "static-1.514",
  "fsm": "static-1.3942",
  "policy-lib": "static-1.6998",
  "react-tinymce": "static-1.55790",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10603",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54916",
  "tinymce-plugins": "static-1.58030",
  "tinymce-themes": "static-1.56886",
  "growth-onboarding-next-action-components": "static-1.2536",
  "user-context-client": "static-1.4754",
  "nest": "static-1.446",
  "unified-auth-core-lib": "static-1.1025",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4742",
  "video-embed": "static-1.36429",
  "social-insights-client-types": "static-1.22606",
  "flux-actions": "static-1.355",
  "integrations-error-boundary-lib": "static-1.14216",
  "integrations-tracking-lib": "static-1.5817",
  "native-integrations-shared-strings": "static-1.7986",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10575",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.743",
  "InboxConnectUtils": "static-4.15368",
  "meetings-connect-utils-lib": "static-1.7815",
  "calling-orchestration-schema": "static-1.36512",
  "crm-record-cards-service-types": "static-1.3730",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16173",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.107",
  "trellis-story-utils": "static-1.4717",
  "storybook-react": "static-1.36",
  "hub-http-contrib": "static-1.3251",
  "tinymce-data": "static-1.41001",
  "ui-addon-sales-email": "static-1.5422",
  "layout-dnd-components": "static-1.12833",
  "layout-dnd-utils": "static-1.11808",
  "ui-brand-identity-lib": "static-1.16040",
  "NamespacedHubStyle": "static-2.9195",
  "outpost": "static-1.4374",
  "universal-page-editor-lib": "static-1.3221",
  "adobe-sign-auth-lib": "static-1.263",
  "ads-unified-auth-lib": "static-1.792",
  "google-sheets-integration-lib": "static-1.840",
  "microsoft-drive-integration-lib": "static-1.957",
  "surveymonkey-integration-lib": "static-1.284",
  "slack-ui-library": "static-1.10609",
  "ContentData": "static-1.69034",
  "layout-data-lib": "static-1.10133",
  "advanced-menus-core": "static-1.15457",
  "advanced-menus-lib": "static-1.12349",
  "ExportDialog": "static-6.10587",
  "ui-memberships-settings-lib": "static-1.34622",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15456",
  "simple-menus-lib": "static-1.16973"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2937",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.489",
  "data-fetching-client": "/data-fetching-client/static-1.9867",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25978",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5803",
  "hs-test-utils": "/hs-test-utils/static-1.8235",
  "hub-http": "/hub-http/static-1.6427",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10457",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18816",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11684",
  "I18n": "/I18n/static-7.1651",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6664",
  "payment-link-components": "/payment-link-components/static-1.23991",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7309",
  "quartz-core": "/quartz-core/static-1.6528",
  "quartz-i18n": "/quartz-i18n/static-1.984",
  "react": "/react/static-7.189",
  "react-colorpicker": "/react-colorpicker/static-2.10419",
  "react-dlb": "/react-dlb/static-1.83",
  "react-utils": "/react-utils/static-2.5487",
  "reselect": "/reselect/static-3.8",
  "rich-text-lib": "/rich-text-lib/static-1.20181",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18272",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5821",
  "UIComponents": "/UIComponents/static-3.8630",
  "foundations-assets": "/foundations-assets/static-1.5085",
  "foundations-components": "/foundations-components/static-1.8319",
  "foundations-theming": "/foundations-theming/static-1.4654",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2370",
  "framer-motion": "/framer-motion/static-1.75",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1283",
  "quartz-config": "/quartz-config/static-1.1087",
  "quartz-routing": "/quartz-routing/static-1.739",
  "quick-fetch": "/quick-fetch/static-1.4063",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16913",
  "rpc-client-utils": "/rpc-client-utils/static-1.4868",
  "sanitize-text": "/sanitize-text/static-1.8357",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.58",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4964",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9743",
  "usage-tracker": "/usage-tracker/static-1.7562",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5979",
  "usage-tracker-core": "/usage-tracker-core/static-1.7412",
  "video-components-external": "/video-components-external/static-1.11937",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3545",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3586",
  "quartz-webpack": "/quartz-webpack/static-1.3533",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.387",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "customer-data-objects": "/customer-data-objects/static-1.7892",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8136",
  "laboratory-lib": "/laboratory-lib/static-3.7361",
  "onboarding-scopes": "/onboarding-scopes/static-1.6668",
  "seat-types-lib": "/seat-types-lib/static-1.486",
  "ui-addon-opt": "/ui-addon-opt/static-4.8570",
  "HeadJS": "/HeadJS/static-2.782",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3346",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.227",
  "ts-schema": "/ts-schema/static-1.4226",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8069",
  "content-media-capture": "/content-media-capture/static-1.5173",
  "cssUtils": "/cssUtils/static-1.855",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10034",
  "file-manager-components": "/file-manager-components/static-1.24234",
  "HubStyle": "/HubStyle/static-2.11991",
  "knowledge-content-types": "/knowledge-content-types/static-1.8601",
  "PatternValidationJS": "/PatternValidationJS/static-1.3107",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10095",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11357",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9290",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10471",
  "video-data-lib": "/video-data-lib/static-1.35595",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4533",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6478",
  "customer-data-properties": "/customer-data-properties/static-1.52297",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19012",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5292",
  "onboarding-tours": "/onboarding-tours/static-1.16980",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8305",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3743",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9283",
  "user-context": "/user-context/static-1.5321",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.859",
  "hubspotter-http": "/hubspotter-http/static-1.4797",
  "icons": "/icons/static-2.668",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.556",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.984",
  "quartz-head": "/quartz-head/static-1.974",
  "quartz-test": "/quartz-test/static-1.984",
  "quartz-tracking": "/quartz-tracking/static-1.688",
  "trellis-components": "/trellis-components/static-1.2374",
  "ui-fonts": "/ui-fonts/static-1.946",
  "usage-tracker-container": "/usage-tracker-container/static-1.7552",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9635",
  "data-token-picker": "/data-token-picker/static-1.16762",
  "FileManagerLib": "/FileManagerLib/static-1.39874",
  "property-translator": "/property-translator/static-1.5605",
  "atom": "/atom/static-1.5286",
  "merchandise-lib": "/merchandise-lib/static-1.269",
  "purchase-motions-components": "/purchase-motions-components/static-1.6229",
  "salesImages": "/salesImages/static-1.529",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5802",
  "react-create-root-preference": "/react-create-root-preference/static-1.51",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.102",
  "ui-images": "/ui-images/static-2.1215",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4588",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.2355",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3137",
  "foundations-theming-base": "/foundations-theming-base/static-1.3639",
  "stylex": "/stylex/static-1.37",
  "interframe": "/interframe/static-3.4965",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5976",
  "web-vitals": "/web-vitals/static-1.9",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.278",
  "chirp-fetch": "/chirp-fetch/static-1.2097",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4687",
  "react-flip-move": "/react-flip-move/static-1.74",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4864",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12977",
  "content-media-compositions": "/content-media-compositions/static-2.16984",
  "idb-keyval": "/idb-keyval/static-1.47",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4358",
  "magpie-lib": "/magpie-lib/static-1.5699",
  "magpie-types": "/magpie-types/static-1.5159",
  "media-bridge-lib": "/media-bridge-lib/static-1.19278",
  "bender-build-tools": "/bender-build-tools/static-1.3323",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3991",
  "superstore": "/superstore/static-1.4968",
  "feedback-loader": "/feedback-loader/static-1.29672",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9477",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8916",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29130",
  "ContentUtils": "/ContentUtils/static-1.68959",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4635",
  "sassPrefix": "/sassPrefix/static-1.160",
  "react-dnd-compat": "/react-dnd-compat/static-1.4824",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1448",
  "copilot-toolkit": "/copilot-toolkit/static-1.11662",
  "avatar-components": "/avatar-components/static-1.2707",
  "navigation-messaging": "/navigation-messaging/static-1.7947",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8387",
  "commerce-products-lib": "/commerce-products-lib/static-1.10296",
  "crm-message-bus": "/crm-message-bus/static-1.43558",
  "growth-data-modal": "/growth-data-modal/static-1.5760",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5087",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5194",
  "batch-promise": "/batch-promise/static-1.1754",
  "calling-global-api": "/calling-global-api/static-1.65209",
  "calling-internal-common": "/calling-internal-common/static-1.31524",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66591",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58885",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3943",
  "crm-links": "/crm-links/static-1.6527",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4411",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4282",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13240",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9784",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8305",
  "external-options-client-types": "/external-options-client-types/static-1.4272",
  "formula-editor": "/formula-editor/static-1.14616",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7104",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "hs-resources": "/hs-resources/static-1.390",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4362",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.841",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3837",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49412",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4112",
  "property-value-citations": "/property-value-citations/static-1.2911",
  "pulse": "/pulse/static-1.826",
  "smart-property-lib": "/smart-property-lib/static-1.8104",
  "tiered-pricing": "/tiered-pricing/static-1.1788",
  "topics-actions-lib": "/topics-actions-lib/static-1.365",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11197",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3270",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2508",
  "navigation-components": "/navigation-components/static-1.18620",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1046",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7852",
  "ui-universal-auth": "/ui-universal-auth/static-1.9229",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18130",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10455",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5248",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1163",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "audio-components": "/audio-components/static-1.6219",
  "FileManagerCore": "/FileManagerCore/static-1.39733",
  "FileManagerImages": "/FileManagerImages/static-1.37385",
  "video-components": "/video-components/static-1.13939",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1344",
  "purchase-motions-api": "/purchase-motions-api/static-1.6232",
  "signup-constants": "/signup-constants/static-1.19391",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8267",
  "usage-tracker-public": "/usage-tracker-public/static-1.7373",
  "reactive-lib": "/reactive-lib/static-1.932",
  "simple-logging-lib": "/simple-logging-lib/static-1.3259",
  "chatspot-core": "/chatspot-core/static-1.22365",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6791",
  "cms-field-types": "/cms-field-types/static-1.5025",
  "content-icons-ui": "/content-icons-ui/static-1.2291",
  "integrations-lib": "/integrations-lib/static-1.16801",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.426",
  "breeze-engine-core": "/breeze-engine-core/static-1.726",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.986",
  "customer-data-tracking": "/customer-data-tracking/static-1.7094",
  "products-iframe-lib": "/products-iframe-lib/static-1.8420",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10839",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1423",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2324",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.546",
  "calling-error-reporting": "/calling-error-reporting/static-1.31531",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11247",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6750",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1735",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7457",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9887",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6651",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7009",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10540",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "sales-views-client-types": "/sales-views-client-types/static-1.4466",
  "bark-lib": "/bark-lib/static-1.16708",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6097",
  "react-codemirror": "/react-codemirror/static-1.10850",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.223",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4152",
  "persist-promise": "/persist-promise/static-1.3911",
  "event-emitter": "/event-emitter/static-1.1160",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.329",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "data-agent-kit": "/data-agent-kit/static-1.514",
  "fsm": "/fsm/static-1.3942",
  "policy-lib": "/policy-lib/static-1.6998",
  "react-tinymce": "/react-tinymce/static-1.55790",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10603",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54916",
  "tinymce-plugins": "/tinymce-plugins/static-1.58030",
  "tinymce-themes": "/tinymce-themes/static-1.56886",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2536",
  "user-context-client": "/user-context-client/static-1.4754",
  "nest": "/nest/static-1.446",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1025",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4742",
  "video-embed": "/video-embed/static-1.36429",
  "social-insights-client-types": "/social-insights-client-types/static-1.22606",
  "flux-actions": "/flux-actions/static-1.355",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14216",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5817",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7986",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10575",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.743",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15368",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7815",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36512",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3730",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16173",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.107",
  "trellis-story-utils": "/trellis-story-utils/static-1.4717",
  "storybook-react": "/storybook-react/static-1.36",
  "hub-http-contrib": "/hub-http-contrib/static-1.3251",
  "tinymce-data": "/tinymce-data/static-1.41001",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5422",
  "layout-dnd-components": "/layout-dnd-components/static-1.12833",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11808",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16040",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9195",
  "outpost": "/outpost/static-1.4374",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3221",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.263",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.792",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.840",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.957",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.284",
  "slack-ui-library": "/slack-ui-library/static-1.10609",
  "ContentData": "/ContentData/static-1.69034",
  "layout-data-lib": "/layout-data-lib/static-1.10133",
  "advanced-menus-core": "/advanced-menus-core/static-1.15457",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12349",
  "ExportDialog": "/ExportDialog/static-6.10587",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34622",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15456",
  "simple-menus-lib": "/simple-menus-lib/static-1.16973"
}
};
